export default __webpack_public_path__ + "static/media/parking-icon.578ab402.svg";